var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"on-board-phase-3"},[_c('b-loading',{attrs:{"is-full-page":true,"active":_vm.isLoading,"can-cancel":false},on:{"update:active":function($event){_vm.isLoading=$event}}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }